import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { ThreadedMessage } from '../types/ThreadedMessage';

const URL = '/v2/threaded-messages';

class ThreadedMessageService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<ThreadedMessage>> {
    return axios.get(URL, config);
  }

  static create(
    data: ThreadedMessage,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<ThreadedMessage>> {
    return axios.post(URL, data, config);
  }
}

export { ThreadedMessageService };
